import React from "react";
import { Outlet } from "react-router-dom";

const DashOutlet = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default DashOutlet;
